import { render, staticRenderFns } from "./questionItem.vue?vue&type=template&id=4e3f6d3c&scoped=true&"
import script from "./questionItem.vue?vue&type=script&lang=ts&"
export * from "./questionItem.vue?vue&type=script&lang=ts&"
import style0 from "./questionItem.vue?vue&type=style&index=0&id=4e3f6d3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3f6d3c",
  null
  
)

export default component.exports